import { desktopCSS, tabletCSS } from '@measures/responsive'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import FirstRow from './FirstRow'
import SecondRow from './SecondRow'

const StyledHeader = styled.header`
  box-sizing: border-box;
  width: 100%;

  ${desktopCSS(css`
    margin: 0 -20px;
    width: calc(100% + 2 * 20px);
  `)}

  ${tabletCSS(css`
    margin: 0 -52px;
    width: calc(100% + 2 * 52px);
  `)}
`

const Header: FunctionComponent = () => {
  return (
    <StyledHeader id="main-header">
      <FirstRow />
      <SecondRow />
    </StyledHeader>
  )
}

export default Header
